





























































































































































import { Component, Vue } from 'vue-property-decorator'
import HeaderUserMenu from '@/app/components/Common/Header/HeaderUserMenu.vue'
import Local from '@/app/module/local'
import { routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    HeaderUserMenu
  }
})
export default class Header extends Vue {
  private isShowUserMenu: boolean = false
  private isAuth: boolean = false
  private isViewer: boolean = true
  private isAllViewer: boolean = false
  private userName: string|null = ''
  private userTypeName: string = '-'
  private constantValue: any = []
  private newsBoardTitle: string = ''

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    let newsBoardTitle = '栽培指導広報'
    if (CommonClass.getServiceFunctionData() !== null) {
      newsBoardTitle = CommonClass.getServiceFunctionData().news_board.news_board_name
    }
    this.newsBoardTitle = newsBoardTitle

    if (Local.getAuthToken()) {
      this.isAuth = true
    }

    if (Local.getUserName()) {
      this.userName = Local.getUserName()
    } else {
      this.userName = '名無し'
    }

    this.jugeUserType()
  }

  private jugeUserType () {
    const userType = parseInt(Local.getUserType()!)
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.constantValue === null) {
      setTimeout(this.jugeUserType, 200)
      return
    }

    // 閲覧者の場合は圃場マップとユーザー情報のみ表示
    switch (userType) {
      case 5:
        break
      case 6:
        this.isViewer = true
        this.isAllViewer = true
        break
      default:
        this.isViewer = false
    }

    // ユーザー情報の表示名を設定
    const userTypeData = this.constantValue.user_types.filter((data: any) => data.user_type_id === userType)
    if (userTypeData.length === 0) {
      this.userTypeName = '-'
    } else {
      this.userTypeName = userTypeData[0].user_type_name
    }
  }

  private showUserMenu () {
    if (this.isShowUserMenu) {
      this.isShowUserMenu = false
    } else {
      this.isShowUserMenu = true
    }
  }

  private isActive (key: string) {
    // マップ・圃場一覧
    switch (key) {
      case 'map':
        if (this.$route.path === routerPath.PATH_FIELD) {
          return true
        }
        break

      case 'news-board':
        if (this.$route.path.indexOf(routerPath.PATH_NEWS_BOARD) === 0) {
          return true
        }
        break

      case 'order':
        if (this.$route.path === routerPath.PATH_FIELD_ORDER) {
          return true
        }
        break

      case 'profit':
        if (this.$route.path === routerPath.PATH_PROFIT) {
          return true
        }
        break

      case 'plant':
        if (this.$route.path === routerPath.PATH_PLANT_LIST ||
              this.$route.path === routerPath.PATH_PLANT_CREATE ||
              this.$route.path.indexOf(routerPath.PATH_PLANT_LIST) === 0) {
          return true
        }
        break

      case 'mypage':
        if (this.$route.path === routerPath.PATH_MY_PAGE) {
          return true
        }
        break

      case 'master':
        if (this.$route.path.indexOf(routerPath.PATH_MASTER) === 0 ||
            this.$route.path.indexOf(routerPath.PATH_EXTERNAL_LINKAGE) === 0) {
          return true
        }
        break

      default:
        break
    }
  }

  private stringCut (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 15) {
        return data.substr(0, 14) + '…'
      } else {
        return data
      }
    }
  }
}
